import type { Editor } from "@tiptap/core";
import type { CoreExtensionNames } from "../constants/extention";
import type { UtilityExtensionStorage } from "../extentions/utility";

interface CharacterCountStorage {
  characters?: (options?: {
    node?: Node;
    mode?: "textSize" | "nodeSize";
  }) => number;
  words?: (options?: { node?: Node }) => number;
}

export interface ExtensionStorageMap {
  [CoreExtensionNames.UTILITY]: UtilityExtensionStorage;
  [CoreExtensionNames.CHARACTERCOUNT]: CharacterCountStorage;
}

export const getExtensionStorage = <K extends keyof ExtensionStorageMap>(
  editor: Editor,
  extensionName: K
): ExtensionStorageMap[K] =>
  (editor.storage as unknown as Record<string, ExtensionStorageMap[K]>)[
    extensionName
  ];
